import React, { useEffect } from 'react'
import {useDispatch,useSelector} from 'react-redux';
import { Button as ReactStrapButton } from 'reactstrap';
import axios from 'axios';
import { ccaa_actions } from '../store/ccaa_slice';
import { useNavigate } from 'react-router-dom';


//antd import statements
import{
    Modal,
    Typography,
    Alert
} from 'antd';

import {
    Text,
    Spinner,
  } from '@chakra-ui/react';

const { Title } = Typography;


function Home() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [form_validated, setFormValidated] = React.useState(false);
  const form_default_values = {
    organization_name: '',
    inclusion_number: '',
    contact_name: '',
    address: '',
    phone_number: '',
    email: ''
    };
const [form_values, setFormValues] = React.useState(form_default_values);
const [isLoading, setIsLoading] = React.useState(false);
const [requestPosted, setRequestPosted] = React.useState(false);

//modal constants

const [open, setOpen] = React.useState(false);
const [open2, setOpen2] = React.useState(false);
const [confirmLoading, setConfirmLoading] = React.useState(false);
const [confirmloading2, setConfirmLoading2] = React.useState(false);
const [modalText, setModalText] = React.useState('Getting Information from ROWHWG Database...');
const [modalText2, setModalText2] = React.useState('Getting Information from ROWHWG Database...');
//redux constants

const home_page_store = useSelector(state => state.ccaa.home_page);


const showModal = () => {
    if(form_validated){
        setOpen(true);
    }
  };

  const handleOk = () => {
    if(form_validated){
        setConfirmLoading(true);
        setTimeout(() => {
            navigate('/MonarchCCAA');
        }
        , 2000);
    }
  };

  const handleCancel = () => {
    setOpen(false);
    setFormValidated(false);
  };

  const showModal2 = () => {
        setOpen2(true);
    };

    const handleOk2 = () => {
        if(form_validated){
            setConfirmLoading2(true);
            setTimeout(() => {
                setOpen2(false);
                setConfirmLoading2(false);
            }
            , 2000);
        }
    };

    const handleCancel2 = () => {
        setOpen2(false);
        setFormValidated(false);
    };


  useEffect(() => {
    ////console.log('home_page_store',home_page_store);
    setFormValues(home_page_store);
  }, [home_page_store]);

  useEffect(() => {
    ////console.log('form_values',form_values);
}, [form_values]);

  useEffect(() => {
    setFormValues({
        organization_name: sessionStorage.getItem('organization_name'),
        inclusion_number: '',
        contact_name: '',
        address: '',
        phone_number: '',
        email: ''
    })
    showModal2();
    fetchUserDetails();
    }, []);

  const fetchUserDetails = async () => {
    const organization_name = sessionStorage.getItem('organization_name');
    try{
        //show modal2
        setModalText2('Getting Information from ROWHWG Database...');
        const user_response = await axios.post('https://rightofway.erc.uic.edu/wp-json/monarch_ccaa_route/v1/monarch_ccaa_id', {
            "organization_name": organization_name
        });
        if(user_response.data[0]){
            //setFormValidated(true);
            dispatch(ccaa_actions.set_home_page(user_response.data[0]));
        }
        else{
            setTimeout(() => {
                setModalText2('No Information Found in ROWHWG Database...');
                setOpen2(false);
                setConfirmLoading2(false);
            }, 2000);
        }
        setOpen2(false);
        setConfirmLoading2(false);
    }
    catch (error) {
        setModalText2('Error Getting Information from ROWHWG Database...');
        setOpen2(false);
        setConfirmLoading2(false);
        return error
    }
};


  const handleFormValidation = (event) => {
    const form = event.currentTarget;
    form.classList.remove('was-validated');
    if (form.checkValidity() === false) {
        form.classList.add('was-validated');
        event.preventDefault();
        //event.stopPropagation();
    }
    else{
        form.classList.add('was-validated');
        setFormValidated(true);
        handleFormSubmit(event);
    }
    };

  useEffect(() => {
    if(form_validated&&requestPosted){
        showModal();
    }
    }, [form_validated,requestPosted]);

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setRequestPosted(true);
    const user_name = sessionStorage.getItem('user_name');
    //console.log('user_name',user_name);
    try{
        const response = await axios.post('https://rightofway.erc.uic.edu/wp-json/monarch_ccaa_route/v1/monarch_ccaa_post',{
            "organization_name": form_values.organization_name,
            "inclusion_number": form_values.inclusion_number,
            "contact_name": form_values.contact_name,
            "address": form_values.address,
            "phone_number": form_values.phone_number,
            "email": form_values.email
        },
        );
        //console.log('response',response);
        setIsLoading(false);
        setRequestPosted(false);
        setFormValidated(true);
        var fetch_response = fetchData();
        fetchAcres();
        resetStore();
        dispatch(ccaa_actions.set_organization_name(form_values.organization_name));
        sessionStorage.setItem('organization_name', form_values.organization_name);
    }
    catch(error){
        setIsLoading(false);
        setRequestPosted(false);
        resetStore();
    }
}

const resetStore = () => {
    dispatch(ccaa_actions.reset_ccca_slice());
    dispatch(ccaa_actions.reset_checkboxes());
}

const fetchAcres = async () => {
    try{
        const response = await axios.post('https://rightofway.erc.uic.edu/wp-json/acres_enrolled_route/v1/acres_enrolled_id',{
            "inclusion_number": form_values.inclusion_number,
        }
        );
        setModalText('Fetched data from ROWHWG');
        if(response.data[0]){
            sessionStorage.setItem('total_enrolled_lands', response.data[0].total_enrolled_lands);
            sessionStorage.setItem('adopted_acres', response.data[0].adopted_acres);
        }
        setOpen(false);
        setConfirmLoading(false);
        navigate('/MonarchCCAA');
        return response
    }
    catch(error){
        return error
    }
}



const fetchData = async () => {
    try{
        const response = await axios.post('https://rightofway.erc.uic.edu/wp-json/monarch_ccaa_route/v1/monarch_ccaa_details',{
            "organization_name": form_values.organization_name,
        }
        );
        setModalText('Fetched data from ROWHWG');
        if(response.data){
            const annual_reporting_res = response.data.monarch_ccaa_annual_reporting[0];
            const annual_net_conservation_res = response.data.monarch_ccaa_annual_net_conservation[0];
            const summary_of_effectiveness_res = response.data.monarch_ccaa_summary_effectiveness[0];
            const upcoming_year_res = response.data.monarch_ccaa_upcoming_year_forecast[0];


            if(annual_reporting_res){
                dispatch(ccaa_actions.set_annual_reporting_summary(annual_reporting_res));
            }
            else{
                dispatch(ccaa_actions.reset_annual_reporting_summary());
            }
            if(annual_net_conservation_res){
                if(annual_net_conservation_res.conservation_measures){
                    var conservation_measures_array = annual_net_conservation_res.conservation_measures.split(',');
                    for(var i = 0; i < conservation_measures_array.length; i++){
                        dispatch(ccaa_actions.set_annual_net_conservation_checkboxes({value: conservation_measures_array[i]}));
                    }
                }
                else{
                    annual_reporting_res.conservation_measures = [];
                }
                if(annual_net_conservation_res.supplement_measures){
                    var supplement_measures_array = annual_net_conservation_res.supplement_measures.split(',');
                    for(var z = 0; z < supplement_measures_array.length; z++){
                        dispatch(ccaa_actions.set_annual_net_conservation_checkboxes({value: supplement_measures_array[z]}));
                    }
                }
                else{
                    annual_reporting_res.supplement_measures = [];
                }
                if(annual_net_conservation_res.updates_to_section_7){
                    let value = annual_net_conservation_res.updates_to_section_7;
                    dispatch(ccaa_actions.set_annual_net_conservation_radio({value: value,checked: true}));
                }
                else{
                    annual_net_conservation_res.updates_to_section_7 = '';
                }
                annual_net_conservation_res.conservation_measures = conservation_measures_array;
                annual_net_conservation_res.supplement_measures = supplement_measures_array;
                dispatch(ccaa_actions.set_annual_net_conservation(annual_net_conservation_res));
            }
            else{
                dispatch(ccaa_actions.reset_annual_net_conservation());
            }
            if(summary_of_effectiveness_res){
                dispatch(ccaa_actions.set_summary_effectiveness(summary_of_effectiveness_res));
                if(summary_of_effectiveness_res.adaptive_management_triggered){
                    let val = summary_of_effectiveness_res.adaptive_management_triggered;
                    dispatch(ccaa_actions.set_summary_effectiveness_radio({value: val,checked: true}));
                }
                else{
                    summary_of_effectiveness_res.adaptive_management_triggered = '';
                }
            }
            else{
                dispatch(ccaa_actions.reset_summary_effectiveness());
            }
            if(upcoming_year_res){
                dispatch(ccaa_actions.set_upcoming_year_forecast(upcoming_year_res));
            }
            else{
                dispatch(ccaa_actions.reset_upcoming_year_forecast());
            }
        }
        return response
    }
    catch(error){
        setModalText('Organization Data not found in ROWHWG');
        return error
    }
}


  const handleInputChange = (e) => {
    const {name, value} = e.target;
    setFormValues({...form_values, [name]: value});
}

  return (
    <div>
        <Modal
        title="Retrieving data..."
        visible={open}
        confirmLoading={confirmLoading}
        okButtonProps={{ style: { display: 'none' } }}
        cancelButtonProps={{ style: { display: 'none' } }}
        onCancel={handleCancel}
        >
        <span>{modalText} <Spinner/></span>
        </Modal>
        <Modal
        title="Retrieving user data..."
        visible={open2}
        confirmLoading={confirmloading2}
        okButtonProps={{ style: { display: 'none' } }}
        cancelButtonProps={{ style: { display: 'none' } }}
        onCancel={handleCancel2}
        >
        <span> {modalText2} <Spinner/> </span>
        </Modal>

        <div className="container-fluid">
        <Title level={3}>Monarch CCAA Annual Reporting Form</Title>
        <Title className="mt-2" level={4}>Partner Information</Title>
        <form className='needs-validation' onSubmit={handleFormValidation} noValidate>
            <div className="form-group m-4">
            <div className="mt-2 mb-2">
                <Alert
                    message="Please note that the Certification of Inclusion Number is case sensitive."
                    type="info"
                    showIcon
                />
                </div>
                <label htmlFor="organization_name">Organization Name</label>
                <input type="text" className="form-control" id="organization_name" name="organization_name" placeholder="Organization Name" required defaultValue={form_values.organization_name} onBlur={handleInputChange}/>
                <div className="invalid-feedback">
                    Please enter your organization name.
                </div>
            </div>
            <div className="form-group m-4">
                <label htmlFor="contact_name">Certification of Inclusion Number</label>
                <input type="text" className="form-control" id="inclusion_number" name="inclusion_number" placeholder="Inclusion Number" required defaultValue={form_values.inclusion_number} onBlur={handleInputChange} />
                <div className="invalid-feedback">
                    Please enter your Inclusion Number.
                </div>
            </div>
            <div className="form-group m-4">
                <label htmlFor="contact_title">Primary Point of Contact Name</label>
                <input type="text" className="form-control" id="contact_name" name="contact_name" placeholder="Contact Name" required defaultValue={form_values.contact_name} onBlur={handleInputChange}/>
                <div className="invalid-feedback">
                    Please enter your Primary Contact Name.
                </div>
            </div>
            <div className="form-group m-4">
                <label htmlFor="contact_email">Address</label>
                <input type="text" className="form-control" id="address" name="address" placeholder="Address" required defaultValue={form_values.address} onBlur={handleInputChange}/>
                <div className="invalid-feedback">
                    Please enter your Address.
                </div>
            </div>
            <div className="form-group m-4">
                <label htmlFor="contact_email">Phone Number</label>
                <input type="text" className="form-control" id="phone_number" name="phone_number" placeholder="Phone Number" required defaultValue={form_values.phone_number} onBlur={handleInputChange}/>
                <div className="invalid-feedback">
                    Please enter your Phone Number.
                </div>
            </div>
            <div className="form-group m-4">
                <label htmlFor="contact_email">Email</label>
                <input type="text" className="form-control" id="email" name="email" placeholder="Contact Email" required defaultValue={form_values.email} onBlur={handleInputChange}/>
                <div className="invalid-feedback">
                    Please enter your Email.
                </div>
            </div>
            <div className="mt-4 form-group m-4">
                <ReactStrapButton color="primary" type="submit">Next</ReactStrapButton>
                {/* {isLoading && requestPosted ? (<div className='row'>
                    <div className='mt-2 col-md-6'>
                      <Text fontSize={'md'} color={'gray.600'}>Posting to ROWHWG Database</Text>
                    </div>
                    <div className='mt-2 col-md-6'>
                      <Spinner />
                    </div>
                  </div>): null} */}
            </div>
        </form>
    </div>
    </div>
  )
}

export default Home
